import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PaymentMethod from "./PaymentMethod";

const PaymentMethodPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { practitionerRoleId } = useParams<{ practitionerRoleId: string }>();
  const totalPrice = location.state?.totalPrice || 0;
  const teleconsultationId = location.state?.teleconsultationId || 0;
  const pertanyaan = location.state?.pertanyaan || null;
  const { selectedPayment, selectedVoucher } = location.state || {};

  return (
    <PaymentMethod
      totalPrice={totalPrice}
      defaultPayment={selectedPayment}
      onSelect={(payment, finalTotal) => {
        navigate(`/checkout-teleconsultation/${practitionerRoleId}`, {
          state: {
            selectedPayment: payment,
            selectedVoucher,
            finalTotal,
            teleconsultationId,
            pertanyaan,
          },
        });
      }}
    />
  );
};

export default PaymentMethodPage;
